module.exports = __webpack_public_path__ + "static/media/031-corsica.6b61335c.svg";